import { css } from "@emotion/css"
import React, { useCallback } from "react"

import Image from "@p-ban/common/src/components/html/Image"
import { removeWhiteSpaceCharacter } from "@p-ban/common/src/utils/StringUtils"

import COLOR_CODE from "../../../constant/color"
import Question from "../icon/Question/Question"
import DisabledOverlay from "../overlay/DisabledOverlay"

type Props = {
  isShow?: boolean
  disabled?: boolean
  legend: string
  src?: string
  helpURL?: string
  mapChildren?: boolean
  children: React.ReactNode
}

const OneClickField = ({
  children,
  isShow = true,
  disabled = false,
  legend,
  src,
  helpURL,
  mapChildren = false,
}: Props) => {
  const open = useCallback(() => {
    window.open(helpURL, "用語説明", "width=400,height=300")
  }, [helpURL])

  if (!isShow) {
    return null
  }

  return (
    // fieldsetがflexに対応してないのでroleを記述してます。
    <div role="group" aria-label={removeWhiteSpaceCharacter(legend)} className={styles.container}>
      <div className={styles.legend}>{legend}</div>
      <div className={styles.help}>{helpURL && <Question onClick={open} />}</div>
      <div className={styles.image}>{src && <Image src={src} alt="" />}</div>
      <div className={styles.contents}>
        {mapChildren ? (
          React.Children.toArray(children).map((child, i) => <FieldContent key={i}>{child}</FieldContent>)
        ) : (
          <FieldContent>{children}</FieldContent>
        )}
      </div>
      {disabled && <DisabledOverlay />}
    </div>
  )
}

export default OneClickField

const FieldContent = ({ children }: { children: React.ReactNode }) => <div className={styles.content}>{children}</div>

const styles = {
  container: css`
    position: relative;
    display: flex;
    width: 100%;
    font-size: 12px;
    color: #32383e;
    > * {
      border: 1px solid #cdd7e1;
      &:not(:last-child) {
        border-right: none;
      }
    }
  `,
  legend: css`
    display: flex;
    align-items: center;
    width: 137px;
    padding: 10px;
    font-size: 13px;
    font-weight: 600;
    font-feature-settings: "palt";
    line-height: 18px;
    white-space: pre-line;
  `,
  help: css`
    display: flex;
    align-items: center;
    width: 22px;
    padding: 4px;
    text-align: center;
    > * {
      z-index: 2;
    }
  `,
  image: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 83px;
    > img {
      max-width: 82px;
    }
  `,
  contents: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
  `,
  content: css`
    position: relative;
    padding: 12px 10px;
    &:not(:last-child) {
      border-bottom: 1px solid ${COLOR_CODE.TABLE_BORDER_DARK_GRAY};
    }
  `,
}
